module.exports = __webpack_public_path__ + "static/media/complete.dbbe83c1.png";